import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
  variant?: 'default' | 'horizontal' | 'compact';
}

export default function ArticleCard({ article, variant = 'default' }: ArticleCardProps) {
  if (variant === 'horizontal') {
    return (
      <Link to={`/article/${article.slug}`} className="flex flex-col sm:flex-row gap-4 group cursor-pointer">
        <div className="relative overflow-hidden rounded-lg bg-background-100 w-full sm:w-48 h-32 flex-shrink-0">
          <img
            src={article.imageUrl}
            alt={article.title}
            title={`${article.title} | 久久精品`}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            loading="lazy"
          />
        </div>
        <div className="flex-1 min-w-0">
          <span className="text-xs text-secondary-600 font-medium mb-1 block">{article.category}</span>
          <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-1">
            {article.title}
          </h3>
          <p className="text-xs text-foreground-500 line-clamp-2 mb-2">{article.excerpt}</p>
          <div className="flex items-center gap-3 text-xs text-foreground-400">
            <span>{article.author}</span>
            <span>{article.publishedAt}</span>
            <span>{article.readTime} 分钟阅读</span>
          </div>
        </div>
      </Link>
    );
  }

  if (variant === 'compact') {
    return (
      <Link to={`/article/${article.slug}`} className="flex items-start gap-3 group cursor-pointer py-3">
        <div className="relative overflow-hidden rounded-md bg-background-100 w-20 h-20 flex-shrink-0">
          <img
            src={article.imageUrl}
            alt={article.title}
            title={`${article.title} | 久久精品`}
            className="w-full h-full object-cover"
            loading="lazy"
          />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-1">
            {article.title}
          </h3>
          <span className="text-xs text-foreground-400">{article.publishedAt}</span>
        </div>
      </Link>
    );
  }

  return (
    <Link to={`/article/${article.slug}`} className="block group cursor-pointer">
      <div className="relative overflow-hidden rounded-lg bg-background-100 aspect-[16/10] mb-3">
        <img
          src={article.imageUrl}
          alt={article.title}
          title={`${article.title} | 久久精品`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
      </div>
      <span className="text-xs text-secondary-600 font-medium mb-1 block">{article.category}</span>
      <h3 className="text-base font-heading font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">
        {article.title}
      </h3>
      <p className="text-sm text-foreground-500 line-clamp-2 mb-3">{article.excerpt}</p>
      <div className="flex items-center gap-3 text-xs text-foreground-400">
        <span>{article.author}</span>
        <span>{article.publishedAt}</span>
        <span>{article.readTime} 分钟阅读</span>
      </div>
    </Link>
  );
}